import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { generateAgreementService } from "./service";
import {
  GenerateAgreementTokenInput,
  GenerateAgreementTokenResponse,
  UseGenerateAgreementMutationOptions
} from "./types";

export function useGenerateAgreementMutation(
  options?: UseGenerateAgreementMutationOptions
) {
  const { open } = useNotification();

  return useMutation<GenerateAgreementTokenResponse, ApiError, GenerateAgreementTokenInput>({
    mutationFn: ({ id }: GenerateAgreementTokenInput) => generateAgreementService(id),
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response?.data?.error,
      });
    },
    ...options,
  });
}
